export default "__VITE_ASSET__3RjW9wGA__"